import plugin from "./main";
export default {
    install(Vue, { store, ...options }) {
        const defaultOptions = {
            namespaced: true,
            accessorName: "wait",
            vuexModuleName: "wait"
        };
        const { accessorName, vuexModuleName } = defaultOptions;
        plugin(store, { ...defaultOptions, ...options });
        Vue.prototype[`$${accessorName}`] = store.getters[`${vuexModuleName}/getWait`];
    }
};
//# sourceMappingURL=index.js.map